import spacetime from 'spacetime';

const getDisplayDate = (dateToDisplay) => {
  const time = spacetime(dateToDisplay, 'UTC').goto('America/Los_Angeles');
  return time.format('{month} {date-ordinal} at {hour}:{minute-pad}{ampm} PT');
};

export default getDisplayDate;
